const ProcessLoader = () => {
  return (
    <div id="ptm-spinner">
      <div className="bounce1" />
      <div className="bounce2" />
      <div className="bounce3" />
      <div className="bounce4" />
      <div className="bounce5" />
    </div>
  );
};

export default ProcessLoader;



// WEBPACK FOOTER //
// ./components/ProcessLoader/index.js